import { FaArrowLeft } from 'react-icons/fa';
import { useState, useEffect } from 'react';

export default function StepEditorHeader({ node, onBack, updateStepSettings }) {
  const [title, setTitle] = useState(node.data.title);

   function handleTitleChange(e){
    setTitle(e.target.value);
    updateStepSettings({...node.data, title: e.target.value});
   }
  return (
    <div className="flex flex-col w-full h-16 border-b-2 border-gray-200 " style={{
       
        overflow: 'hidden',
        zIndex: 1000,
        marginTop: '40px',

    }}>
        <div className="flex items-center  p-2 bg-white">
            <button onClick={onBack} className="text-blue-500">
                <FaArrowLeft />
            </button>
            <input type="text" value={title} onChange={handleTitleChange} className="p-4 font-bold w-full" />
        </div>
    </div>
  );
}